import "./CheckBox.css";
import { useRef, useState } from "react";
import { randomUUID } from "../../axios_with_token";

export default function CheckBox({fldName, form, fldDef, opts}){
    // opts: {type, singleValue}
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    const [checkedItems, setCheckedItems] = useState((fldValue=>{
      const val = {};
      fldValue.split(',').filter(a=>a).forEach(valItem=>{
        val[valItem] = true;
      });
      return val;
    })(form.getValues()[fldName] || ''));

    const getCheckedValues = (chkValue) => {
      return Object.entries(chkValue || checkedItems)
        .filter(([key, value]) => value)
        .map(([key]) => key);
    };

    const handleCheckboxChange = (event) => {
      // [] this set, the value only take effect in next rendering, so use chkValue to use immediate value to set form value
      setCheckedItems((prev) => {
        const chkValue = {
          ...(opts.singleValue?{}:prev),
          [event.target.value]: opts.singleValue?[true]:!prev[event.target.value],
        };

        console.log(' getCheckedValues().join(','):',  getCheckedValues(chkValue).join(','));
        form.setValue(fldName, getCheckedValues(chkValue).join(','));

        return chkValue;
      });
    };


    // options [[val1, caption1], [val2, caption2], ...]
    const chkboxId = `chkboxid-${randomUUID()}`;
    return <div className="form-check">
        {/* <input className="form-control"
            type="hidden"
            ref={refValue}
            {...rest}
        /> */}

      {(fldDef.src||[]).map((optDef) => {
        const [valItem, cap] = optDef.constructor == Array? optDef : [optDef, optDef];
        return <div 
          key={valItem}
          className="me-3"
          style={{display:"inline-block"}}
        >
          <input
            type={opts.type || "checkbox"}
            value={valItem}
            checked={checkedItems[valItem]}
            id={`${chkboxId}-${valItem}`}
            className="me-1"
            onChange={handleCheckboxChange}
          />
          <label htmlFor={`${chkboxId}-${valItem}`}>{cap}</label>
        </div>
      })}

      {/* {Object.keys(checkedItems).map((item, index) => (
        <div key={index}>
          <input
            type="checkbox"
            name="checkbox-group"
            value={item}
            checked={checkedItems[item]}
            onChange={handleCheckboxChange}
            id={item}
          />
          <label htmlFor={item}>{item}</label>
        </div>
      ))} */}

    </div>;
}